import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'view-switcher',
  templateUrl: './view-switcher.component.html',
  styleUrls: ['./view-switcher.component.scss']
})
export class ViewSwitcherComponent implements OnInit {
  @Input() views: any = [];
  @Output() onSwitch = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  switch($event, view) {
    this.views.forEach((theView) => { theView.isActive = false; });
    view.isActive = true;
    this.onSwitch.emit({ view: view.id, event: $event });
  }
}
